const prefix = 'cvf-admin/regions/';

export const GET_ALL_REGIONS = `${prefix}GET_ALL_REGIONS`;
export const GET_ALL_REGIONS_SUCCESS = `${prefix}GET_ALL_REGIONS_SUCCESS`;
export const GET_ALL_REGIONS_ERROR = `${prefix}GET_ALL_REGIONS_ERROR`;
